var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Button, Checkbox, Form as UIForm, Message } from 'semantic-ui-react';
import * as Authentication from '~/Api/Authentication';
import { useApi, useApiResult } from '~/ApiHooks';
import { GdprConsentFromInvitationRequest, } from '~/Api/User';
import { LoginRoute } from '~/Application/routes';
export var Invitation = function (_a) {
    var token = _a.token, userId = _a.userId;
    var minLength = Authentication.PasswordMinLength;
    var _b = React.useState(false), error = _b[0], setError = _b[1];
    var _c = React.useState(null), passwordError = _c[0], setPasswordError = _c[1];
    var _d = React.useState(null), passwordCheckError = _d[0], setPasswordCheckError = _d[1];
    var _e = React.useState(''), password = _e[0], setPassword = _e[1];
    var _f = React.useState(''), passwordCheck = _f[0], setPasswordCheck = _f[1];
    var _g = React.useState(false), gdprConsent = _g[0], setGdprConsent = _g[1];
    var _h = React.useState(true), directMarketingConsent = _h[0], setDirectMarketingConsent = _h[1];
    var _j = React.useState(true), showGdprConsentWarning = _j[0], setShowGdprConsentWarning = _j[1];
    var redirectToLogin = LoginRoute.useRedirect();
    var passwordResetResult = useApiResult(new Authentication.PasswordResetRequest(token, userId), [token, userId])[0];
    var _k = useApi(), postPasswordReset = _k[0], postPasswordResetResult = _k[1];
    var _l = useApi(), postGdprConsent = _l[0], postGdprConsentResult = _l[1];
    React.useEffect(function () {
        var _a;
        setError(false);
        if (passwordResetResult.isLoading) {
            return;
        }
        if (!passwordResetResult.value || !((_a = passwordResetResult.value) === null || _a === void 0 ? void 0 : _a.passwordReset.active)) {
            setError(true);
        }
    }, [passwordResetResult]);
    var handleGdprConsent = function (checked) {
        if (checked === undefined) {
            return;
        }
        if (checked) {
            setShowGdprConsentWarning(false);
        }
        else {
            setShowGdprConsentWarning(true);
        }
        setGdprConsent(checked);
    };
    var handleDirectMarketingConsent = function (checked) {
        if (checked === undefined) {
            return;
        }
        setDirectMarketingConsent(checked);
    };
    var setPasswordHandler = function (value) {
        setPasswordError(null);
        setPassword(value);
    };
    var setPasswordCheckHandler = function (value) {
        setPasswordCheckError(null);
        setPasswordCheck(value);
    };
    var handleFormSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var gdprConsentResponse, passwordResetResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    if (password.length < minLength) {
                        setPasswordError("Heslo mus\u00ED m\u00EDt alespo\u0148 ".concat(minLength, " znak\u016F"));
                        return [2 /*return*/];
                    }
                    else if (Authentication.isPasswordTooBig(password)) {
                        setPasswordError('Heslo je moc dlouhé');
                    }
                    else if (password !== passwordCheck) {
                        setPasswordCheckError('Hesla se neshodují, zkuste to prosím znovu');
                        return [2 /*return*/];
                    }
                    if (!gdprConsent) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, postGdprConsent(new GdprConsentFromInvitationRequest(token, gdprConsent, directMarketingConsent))];
                case 1:
                    gdprConsentResponse = _a.sent();
                    if (gdprConsentResponse.error !== null) {
                        setError(true);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, postPasswordReset(new Authentication.PasswordSetupRequest(token, userId, password))];
                case 2:
                    passwordResetResponse = _a.sent();
                    if (passwordResetResponse.error !== null) {
                        setError(true);
                        return [2 /*return*/];
                    }
                    redirectToLogin({});
                    return [2 /*return*/];
            }
        });
    }); };
    return (<>
			{error && (<div>
					<Message negative>
						<Message.Header>Neplatný požadavek</Message.Header>
						<p>
							Pozvánka již byla přijata nebo zrušena. Zkontrolujte svůj e-mail a zkuste to znovu nebo se nám prosím
							ozvěte na email <a href={"mailto:support@cogvio.com"}>support@cogvio.com</a>
						</p>
					</Message>
				</div>)}

			{!error && (<UIForm noValidate onSubmit={handleFormSubmit}>
					<p>Zvolte heslo alespoň {minLength} znaků dlouhé</p>

					<UIForm.Input fluid required disabled={postPasswordResetResult.isLoading || postGdprConsentResult.isLoading} error={passwordError} icon='lock' iconPosition='left' label='Heslo' type='password' onChange={function (event) { return setPasswordHandler(event.target.value); }}/>
					<UIForm.Input fluid required disabled={postPasswordResetResult.isLoading || postGdprConsentResult.isLoading} error={passwordCheckError} icon='lock' iconPosition='left' label='Heslo' type='password' onChange={function (event) { return setPasswordCheckHandler(event.target.value); }}/>

					<div className='consent'>
						<div className='consentCheckbox'>
							<Checkbox checked={gdprConsent} onChange={function (e, data) { return handleGdprConsent(data.checked); }}/>
						</div>
						<div>
							<div className='consentHeading'>
								Souhlas s podmínkami uživatelského účtu a informacemi o zpracování osobních údajů.
							</div>
							<div className='consentText'>
								Zatržením pole souhlasím s podmínkami uživatelského účtu a beru na vědomí informace o zpracování
								osobních údajů pro účely registrace, to vše dostupné <a href={'https://www.cogvio.com/terms/'}>zde</a>.
							</div>
						</div>
					</div>

					<div className='consent'>
						<div className='consentCheckbox'>
							<Checkbox checked={directMarketingConsent} onChange={function (e, data) { return handleDirectMarketingConsent(data.checked); }}/>
						</div>
						<div>
							<div className='consentHeading'>Souhlas s přímým marketingem.</div>
							<div className='consentText'>
								Jako náš zákazník budete získávat elektronická obchodní sdělení dle podmínek stanovených{' '}
								<a href={'https://www.cogvio.com/terms/'}>zde</a>. Tento souhlas je možné vzít kdykoliv zpět.
							</div>
						</div>
					</div>

					{showGdprConsentWarning && (<Message>
							<p className='consentWarning'>
								Pokud si nepřejete udělit Souhlas s podmínkami uživatelského účtu a informacemi o zpracování osobních
								údajů, ozvěte se nám prosím na email <a href={"mailto:support@cogvio.com"}>support@cogvio.com</a>.
							</p>
						</Message>)}

					<Button disabled={password === '' || postPasswordResetResult.isLoading || postGdprConsentResult.isLoading || !gdprConsent} size='large'>
						Dokončit registraci
					</Button>
				</UIForm>)}
		</>);
};
